import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { JsonEncryptDecrypt } from '@brafton/common-framework-library';

@Injectable({ providedIn: 'root' })
export class MockApiService {
  constructor(private jsonEncDec: JsonEncryptDecrypt) {}
  public decycle(): Observable<any> {
    return of(this.jsonEncDec.decycle(dataSimple));
  }

  public cycle(): Observable<any> {
    return of(this.jsonEncDec.retrocycle(dataComplex));
  }
}

const dataComplex = {
  $id: '1',
  id: '6523da3cac359cd86d7b1a1e',
  fields: [
    {
      $id: '2',
      id: '6523da3cac359cd86d7b1a1f',
      value: 'Understanding OSHA Regulations',
      required: true,
      fieldDefinition: {
        $id: '3',
        type: { $id: '4', displayName: 'Single Text Field Plain', id: 'SingleTextFieldPlain' },
        id: '6523da3cac359cd86d7b1a15',
        required: true,
        name: 'Title',
        order: 1,
        parent: {
          $id: '5',
          id: '6523da3cac359cd86d7b1a14',
          fields: [
            { $ref: '3' },
            {
              $id: '6',
              id: '6523da3cac359cd86d7b1a16',
              name: 'Sections',
              type: { $id: '7', displayName: 'Sub Text Set Field', id: 'SubTextSetField' },
              order: 2,
              singletonValue: false,
              required: false,
              textSetDefinition: {
                $id: '8',
                id: '6523da3cac359cd86d7b1a17',
                fields: [
                  {
                    $id: '9',
                    type: { $ref: '4' },
                    id: '6523da3cac359cd86d7b1a18',
                    required: true,
                    name: 'Title',
                    order: 1,
                    parent: { $ref: '8' },
                  },
                  {
                    $id: '10',
                    id: '6523da3cac359cd86d7b1a19',
                    name: 'Topics',
                    type: { $ref: '7' },
                    order: 2,
                    singletonValue: false,
                    required: false,
                    textSetDefinition: {
                      $id: '11',
                      id: '6523da3cac359cd86d7b1a1a',
                      fields: [
                        {
                          $id: '12',
                          type: { $ref: '4' },
                          id: '6523da3cac359cd86d7b1a1b',
                          required: true,
                          name: 'Topic',
                          order: 1,
                          parent: { $ref: '11' },
                        },
                        {
                          $id: '13',
                          id: '6523da3cac359cd86d7b1a1c',
                          required: true,
                          name: 'Type',
                          type: { $id: '14', displayName: 'Pick List', id: 'PickList' },
                          order: 2,
                          parent: { $ref: '11' },
                          pickListValues: ['Paragraph', 'Few Sentences', 'Expand Few Sentences', 'Expand Paragraph'],
                        },
                        {
                          $id: '15',
                          id: '6523da3cac359cd86d7b1a1d',
                          required: false,
                          name: 'Link',
                          type: { $id: '16', displayName: 'Hyperlink', id: 'Hyperlink' },
                          order: 3,
                          parent: { $ref: '11' },
                        },
                      ],
                      name: 'Topics',
                      version: 1,
                      coreId: '6523da3cac359cd86d7b1a1a',
                      versionType: { $id: '17', displayName: 'Current Version', id: 'Current' },
                      createdDate: '2023-10-09T10:47:24.035733Z',
                      modifiedDate: '2023-10-09T10:47:24.0357335Z',
                      owner: null,
                    },
                    parent: { $ref: '8' },
                  },
                ],
                name: 'Sections',
                version: 1,
                coreId: '6523da3cac359cd86d7b1a17',
                versionType: { $ref: '17' },
                createdDate: '2023-10-09T10:47:24.0352452Z',
                modifiedDate: '2023-10-09T10:47:24.0352457Z',
                owner: null,
              },
              parent: { $ref: '5' },
            },
          ],
          name: 'Blog Outline',
          version: 1,
          coreId: '6523da3cac359cd86d7b1a14',
          versionType: { $ref: '17' },
          createdDate: '2023-10-09T10:47:24.0328274Z',
          modifiedDate: '2023-10-09T10:47:24.0332087Z',
          owner: null,
        },
      },
      name: 'Title',
      type: { $ref: '4' },
      order: 0,
      parent: { $ref: '1' },
    },
    {
      $id: '18',
      id: '6523da3cac359cd86d7b1a20',
      name: 'Sections',
      type: { $ref: '7' },
      fieldDefinition: { $ref: '6' },
      order: 2,
      singletonValue: false,
      required: false,
      textSets: [
        {
          $id: '19',
          id: '6523da3cac359cd86d7b1a21',
          fields: [
            {
              $id: '20',
              id: '6523da3cac359cd86d7b1a22',
              value: 'Introduction',
              required: true,
              fieldDefinition: { $ref: '9' },
              name: 'Title',
              type: { $ref: '4' },
              order: 0,
              parent: { $ref: '19' },
            },
            {
              $id: '21',
              id: '6523da3cac359cd86d7b1a23',
              name: 'Topics',
              type: { $ref: '7' },
              fieldDefinition: { $ref: '10' },
              order: 2,
              singletonValue: false,
              required: false,
              textSets: [
                {
                  $id: '22',
                  id: '6523da3cac359cd86d7b1a24',
                  fields: [
                    {
                      $id: '23',
                      id: '6523da3cac359cd86d7b1a25',
                      value: 'Define OSHA and it’s purpose',
                      required: true,
                      fieldDefinition: { $ref: '12' },
                      name: 'Topic',
                      type: { $ref: '4' },
                      order: 0,
                      parent: { $ref: '22' },
                    },
                    {
                      $id: '24',
                      id: '6523da3cac359cd86d7b1a26',
                      value: 'Paragraph',
                      fieldDefinition: { $ref: '13' },
                      required: true,
                      name: 'Type',
                      type: { $ref: '14' },
                      order: 0,
                      parent: { $ref: '22' },
                    },
                    {
                      $id: '25',
                      id: '6523da3cac359cd86d7b1a27',
                      value: null,
                      anchorText: null,
                      required: false,
                      fieldDefinition: { $ref: '15' },
                      name: 'Link',
                      type: { $ref: '16' },
                      order: 0,
                      parent: { $ref: '22' },
                    },
                  ],
                  name: 'Topic 1',
                  definition: { $ref: '11' },
                  createdDate: '2023-10-09T10:47:24.042326Z',
                  modifiedDate: '2023-10-09T10:47:24.042326Z',
                  owner: null,
                  parentField: { $ref: '21' },
                },
                {
                  $id: '26',
                  id: '6523da3cac359cd86d7b1a28',
                  fields: [
                    {
                      $id: '27',
                      id: '6523da3cac359cd86d7b1a29',
                      value:
                        'Compliance protects both employers and employees — consequences of violations from financial penalties to potential shutdowns',
                      required: true,
                      fieldDefinition: { $ref: '12' },
                      name: 'Topic',
                      type: { $ref: '4' },
                      order: 0,
                      parent: { $ref: '26' },
                    },
                    {
                      $id: '28',
                      id: '6523da3cac359cd86d7b1a2a',
                      value: 'Paragraph',
                      fieldDefinition: { $ref: '13' },
                      required: true,
                      name: 'Type',
                      type: { $ref: '14' },
                      order: 0,
                      parent: { $ref: '26' },
                    },
                    {
                      $id: '29',
                      id: '6523da3cac359cd86d7b1a2b',
                      value: 'https://www.ffvamutual.com/blog/how-does-osha-enforce-its-standards/',
                      anchorText: 'How Does OSHA Enforce Its Standards? - FFVA Mutual',
                      required: false,
                      fieldDefinition: { $ref: '15' },
                      name: 'Link',
                      type: { $ref: '16' },
                      order: 0,
                      parent: { $ref: '26' },
                    },
                  ],
                  name: 'Topic 2',
                  definition: { $ref: '11' },
                  createdDate: '2023-10-09T10:47:24.047422Z',
                  modifiedDate: '2023-10-09T10:47:24.047422Z',
                  owner: null,
                  parentField: { $ref: '21' },
                },
              ],
              parent: { $ref: '19' },
            },
          ],
          name: 'Section 1',
          definition: { $ref: '8' },
          createdDate: '2023-10-09T10:47:24.0427446Z',
          modifiedDate: '2023-10-09T10:47:24.0427446Z',
          owner: null,
          parentField: { $ref: '18' },
        },
        {
          $id: '30',
          id: '6523da3cac359cd86d7b1a2c',
          fields: [
            {
              $id: '31',
              id: '6523da3cac359cd86d7b1a2d',
              value: 'Understanding OSHA Regulations',
              required: true,
              fieldDefinition: { $ref: '9' },
              name: 'Title',
              type: { $ref: '4' },
              order: 0,
              parent: { $ref: '30' },
            },
            {
              $id: '32',
              id: '6523da3cac359cd86d7b1a2e',
              name: 'Topics',
              type: { $ref: '7' },
              fieldDefinition: { $ref: '10' },
              order: 2,
              singletonValue: false,
              required: false,
              textSets: [
                {
                  $id: '33',
                  id: '6523da3cac359cd86d7b1a2f',
                  fields: [
                    {
                      $id: '34',
                      id: '6523da3cac359cd86d7b1a30',
                      value: 'Employer Musts',
                      required: true,
                      fieldDefinition: { $ref: '12' },
                      name: 'Topic',
                      type: { $ref: '4' },
                      order: 0,
                      parent: { $ref: '33' },
                    },
                    {
                      $id: '35',
                      id: '6523da3cac359cd86d7b1a31',
                      value: 'Paragraph',
                      fieldDefinition: { $ref: '13' },
                      required: true,
                      name: 'Type',
                      type: { $ref: '14' },
                      order: 0,
                      parent: { $ref: '33' },
                    },
                    {
                      $id: '36',
                      id: '6523da3cac359cd86d7b1a32',
                      value: null,
                      anchorText: null,
                      required: false,
                      fieldDefinition: { $ref: '15' },
                      name: 'Link',
                      type: { $ref: '16' },
                      order: 0,
                      parent: { $ref: '33' },
                    },
                  ],
                  name: 'Topic 1',
                  definition: { $ref: '11' },
                  createdDate: '2023-10-09T10:47:24.0477892Z',
                  modifiedDate: '2023-10-09T10:47:24.0477892Z',
                  owner: null,
                  parentField: { $ref: '32' },
                },
                {
                  $id: '37',
                  id: '6523da3cac359cd86d7b1a33',
                  fields: [
                    {
                      $id: '38',
                      id: '6523da3cac359cd86d7b1a34',
                      value: 'Employees’ rights',
                      required: true,
                      fieldDefinition: { $ref: '12' },
                      name: 'Topic',
                      type: { $ref: '4' },
                      order: 0,
                      parent: { $ref: '37' },
                    },
                    {
                      $id: '39',
                      id: '6523da3cac359cd86d7b1a35',
                      value: 'Paragraph',
                      fieldDefinition: { $ref: '13' },
                      required: true,
                      name: 'Type',
                      type: { $ref: '14' },
                      order: 0,
                      parent: { $ref: '37' },
                    },
                    {
                      $id: '40',
                      id: '6523da3cac359cd86d7b1a36',
                      value: null,
                      anchorText: null,
                      required: false,
                      fieldDefinition: { $ref: '15' },
                      name: 'Link',
                      type: { $ref: '16' },
                      order: 0,
                      parent: { $ref: '37' },
                    },
                  ],
                  name: 'Topic 2',
                  definition: { $ref: '11' },
                  createdDate: '2023-10-09T10:47:24.0478003Z',
                  modifiedDate: '2023-10-09T10:47:24.0478003Z',
                  owner: null,
                  parentField: { $ref: '32' },
                },
                {
                  $id: '41',
                  id: '6523da3cac359cd86d7b1a37',
                  fields: [
                    {
                      $id: '42',
                      id: '6523da3cac359cd86d7b1a38',
                      value: 'Definition of OSHA standards',
                      required: true,
                      fieldDefinition: { $ref: '12' },
                      name: 'Topic',
                      type: { $ref: '4' },
                      order: 0,
                      parent: { $ref: '41' },
                    },
                    {
                      $id: '43',
                      id: '6523da3cac359cd86d7b1a39',
                      value: 'Paragraph',
                      fieldDefinition: { $ref: '13' },
                      required: true,
                      name: 'Type',
                      type: { $ref: '14' },
                      order: 0,
                      parent: { $ref: '41' },
                    },
                    {
                      $id: '44',
                      id: '6523da3cac359cd86d7b1a3a',
                      value: 'https://www.ffvamutual.com/blog/osha-recordkeeping-rule-updates-whats-new-in-2019/',
                      anchorText: 'OSHA Recordkeeping Rule Updates - FFVA Mutual',
                      required: false,
                      fieldDefinition: { $ref: '15' },
                      name: 'Link',
                      type: { $ref: '16' },
                      order: 0,
                      parent: { $ref: '41' },
                    },
                  ],
                  name: 'Topic 3',
                  definition: { $ref: '11' },
                  createdDate: '2023-10-09T10:47:24.0478048Z',
                  modifiedDate: '2023-10-09T10:47:24.0478048Z',
                  owner: null,
                  parentField: { $ref: '32' },
                },
                {
                  $id: '45',
                  id: '6523da3cac359cd86d7b1a3b',
                  fields: [
                    {
                      $id: '46',
                      id: '6523da3cac359cd86d7b1a3c',
                      value: 'Explain the different sectors affected by OSHA',
                      required: true,
                      fieldDefinition: { $ref: '12' },
                      name: 'Topic',
                      type: { $ref: '4' },
                      order: 0,
                      parent: { $ref: '45' },
                    },
                    {
                      $id: '47',
                      id: '6523da3cac359cd86d7b1a3d',
                      value: 'Paragraph',
                      fieldDefinition: { $ref: '13' },
                      required: true,
                      name: 'Type',
                      type: { $ref: '14' },
                      order: 0,
                      parent: { $ref: '45' },
                    },
                    {
                      $id: '48',
                      id: '6523da3cac359cd86d7b1a3e',
                      value: null,
                      anchorText: null,
                      required: false,
                      fieldDefinition: { $ref: '15' },
                      name: 'Link',
                      type: { $ref: '16' },
                      order: 0,
                      parent: { $ref: '45' },
                    },
                  ],
                  name: 'Topic 4',
                  definition: { $ref: '11' },
                  createdDate: '2023-10-09T10:47:24.0478184Z',
                  modifiedDate: '2023-10-09T10:47:24.0478184Z',
                  owner: null,
                  parentField: { $ref: '32' },
                },
              ],
              parent: { $ref: '30' },
            },
          ],
          name: 'Section 2',
          definition: { $ref: '8' },
          createdDate: '2023-10-09T10:47:24.0477905Z',
          modifiedDate: '2023-10-09T10:47:24.0477905Z',
          owner: null,
          parentField: { $ref: '18' },
        },
      ],
      parent: { $ref: '1' },
    },
  ],
  name: 'Blog Outline',
  definition: { $ref: '5' },
  createdDate: '2023-10-09T10:47:24.0427459Z',
  modifiedDate: '2023-10-09T10:47:24.0427459Z',
  owner: null,
};

const dataSimple = {
  $id: '1',
  id: '6525389a4f772e1e6de7e1d3',
  fields: [
    {
      $id: '2',
      id: '6525389a4f772e1e6de7e1d4',
      value: 'Blog #1',
      required: true,
      fieldDefinition: {
        $id: '3',
        type: { $id: '4', displayName: 'Single Text Field Plain', id: 'SingleTextFieldPlain' },
        id: '6525389a4f772e1e6de7e1d1',
        required: true,
        name: 'Heading',
        order: 1,
        parent: {
          $id: '5',
          id: '6525389a4f772e1e6de7e1d0',
          fields: [
            { $ref: '3' },
            {
              $id: '6',
              type: { $id: '7', displayName: 'MultiLine Text Field Plain', id: 'MultiLineTextFieldPlain' },
              id: '6525389a4f772e1e6de7e1d2',
              required: false,
              name: 'Contents',
              order: 2,
              parent: { $ref: '5' },
            },
          ],
          name: 'Blog Article',
          version: 1,
          coreId: '6525389a4f772e1e6de7e1d0',
          versionType: { $id: '8', displayName: 'Current Version', id: 'Current' },
          createdDate: '2023-10-10T11:42:18.6403553Z',
          modifiedDate: '2023-10-10T11:42:18.6407342Z',
          owner: null,
        },
      },
      name: 'Heading',
      type: { $ref: '4' },
      order: 0,
      parent: { $ref: '1' },
    },
    {
      $id: '9',
      id: '6525389a4f772e1e6de7e1d5',
      value: null,
      required: false,
      fieldDefinition: { $ref: '6' },
      name: 'Contents',
      type: { $ref: '4' },
      order: 0,
      parent: { $ref: '1' },
    },
  ],
  name: 'Blog #1',
  definition: { $ref: '5' },
  createdDate: '2023-10-10T11:42:18.6524973Z',
  modifiedDate: '2023-10-10T11:42:18.6524973Z',
  owner: null,
  organizationDetails: {
    $id: '10',
    organizationId: '123456asdfgh',
    organizationName: 'SomeOrg',
    feedId: 705,
    feedName: 'SomeOrg',
    accountId: 1,
    accountName: 'Brafton',
    region: null,
  },
};
